// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.header_header__MhatS {
  position: fixed;
  display: flex;
  top: 0;
  left: 0;
  z-index: 6;
  width: 100vw;
  height: 56px;
  background: #ffffff; }
  .header_header__MhatS .header_logo__UESgy {
    padding: 0 0 0 13px;
    width: 160px;
    min-width: 160px;
    display: flex;
    align-items: center; }
    .header_header__MhatS .header_logo_svg__3AKNy {
      width: 110px;
      height: 22px; }
  .header_header__MhatS .header_content__Oq5rs {
    border-bottom: 1px solid #e0e0e0;
    padding: 0 30px;
    display: flex;
    align-items: center;
    width: 100%; }
    .header_header__MhatS .header_content__Oq5rs h1 {
      font-weight: 600;
      font-size: 16px;
      line-height: 24px;
      margin-right: 28px;
      white-space: nowrap; }

.header_container__7HyC8 {
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: space-between; }

.header_noTabs__6zx54 {
  justify-content: flex-end; }
`, "",{"version":3,"sources":["webpack://./src/components/header/header.module.scss"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,aAAa;EACb,MAAM;EACN,OAAO;EACP,UAAU;EACV,YAAY;EACZ,YAAY;EACZ,mBAAmB,EAAA;EARrB;IAWI,mBAAmB;IACnB,YAAY;IACZ,gBAAgB;IAChB,aAAa;IACb,mBAAmB,EAAA;IAfvB;MAiBM,YAAY;MACZ,YAAY,EAAA;EAlBlB;IAsBI,gCAAgC;IAChC,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,WAAW,EAAA;IA1Bf;MA4BM,gBAAgB;MAChB,eAAe;MACf,iBAAiB;MACjB,kBAAkB;MAClB,mBAAmB,EAAA;;AAKzB;EACE,aAAa;EACb,WAAW;EACX,mBAAmB;EACnB,8BAA8B,EAAA;;AAGhC;EACE,yBAAyB,EAAA","sourcesContent":[".header {\n  position: fixed;\n  display: flex;\n  top: 0;\n  left: 0;\n  z-index: 6;\n  width: 100vw;\n  height: 56px;\n  background: #ffffff;\n\n  .logo {\n    padding: 0 0 0 13px;\n    width: 160px;\n    min-width: 160px;\n    display: flex;\n    align-items: center;\n    &_svg {\n      width: 110px;\n      height: 22px;\n    }\n  }\n  .content {\n    border-bottom: 1px solid #e0e0e0;\n    padding: 0 30px;\n    display: flex;\n    align-items: center;\n    width: 100%;\n    h1 {\n      font-weight: 600;\n      font-size: 16px;\n      line-height: 24px;\n      margin-right: 28px;\n      white-space: nowrap;\n    }\n  }\n}\n\n.container{\n  display: flex;\n  width: 100%;\n  align-items: center;\n  justify-content: space-between;\n  \n}\n.noTabs{\n  justify-content: flex-end;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"header": `header_header__MhatS`,
	"logo": `header_logo__UESgy`,
	"logo_svg": `header_logo_svg__3AKNy`,
	"content": `header_content__Oq5rs`,
	"container": `header_container__7HyC8`,
	"noTabs": `header_noTabs__6zx54`
};
export default ___CSS_LOADER_EXPORT___;
